/**
 * Utility functions for attachment picker providers
 */

/**
 * Map location to the correct region format for contextId
 * @param location - The service region location (e.g., 'northAmerica', 'europe')
 * @returns The mapped region identifier (e.g., 'us', 'eu')
 */
export function mapServiceRegionToRegion(location: string): string {
  const regionMapping: Record<string, string> = {
    northAmerica: 'us',
    europe: 'eu',
    asia: 'ap',
    australia: 'ap-au',
  };
  return regionMapping[location] || location;
}
